export * from './firebase.app.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// d:/xampp/htdocs/zenith-admin/~/angularfire2/app/index.js
// module id = ../../../../angularfire2/app/index.js
// module chunks = 4